module.exports = __webpack_public_path__ + "img/ic_market_set_default.2741b8ec.svg";